import Cookies from "js-cookie";
window.$ = window.jQuery = require("jquery");
window.moneyFormats = {
    "USD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} USD"
    },
    "EUR": {
      "money_format": "&euro;{{amount}}",
      "money_with_currency_format": "&euro;{{amount}} EUR"
    },
    "GBP": {
      "money_format": "&pound;{{amount}}",
      "money_with_currency_format": "&pound;{{amount}} GBP"
    },
    "CAD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} CAD"
    },
    "AUD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} AUD"
    },
    "NZD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} NZD"
    }
  };

import './styles/tailwind.scss';
import './styles/theme.scss';
import './scripts/announcment';
import './scripts/templates/product/index.tsx';
import './scripts/templates/cart/index.tsx';
import './scripts/templates/blog/blog'

window.addEventListener('load', () => {
  const sideCart = document.getElementById('sidebar-cart');
  setTimeout(()=>{
    if(sideCart) {
      sideCart.classList.remove('hidden');
    }
  },2000);

  const changeMode = document.querySelectorAll('[data-action="change-layout-mode"]');
  if(changeMode && changeMode.length > 0) {
    changeMode.forEach(element=>{
      element.addEventListener('click',()=>{
        Cookies.set('_gridLayout',element.dataset.count);
      });
    });
  }
  if(Cookies.get('_gridLayout')) {
    var count = Cookies.get('_gridLayout');
    const bcsfContainer = document.querySelector('#bc-sf-filter-products')
    if(count){
      const selected = window.innerWidth > 640 ? count < 5 && count > 2 ? count : 3 : count < 3 && count > 0 ? count : 2
      if(window.innerWidth > 640){
        document.querySelector(`[data-action="change-layout-mode"][data-count="${selected}"]`).click(); 
        bcsfContainer.setAttribute('data-desktop-count', selected)
      }
      else{
        document.querySelector(`[data-action="change-layout-mode"][data-count="${selected}"]`).click(); 
        bcsfContainer.setAttribute('data-mobile-count', selected)
      }
    }
    else{
      if(window.innerWidth > 640){
        document.querySelector(`[data-action="change-layout-mode"][data-count="3"]`).click();
      }
      else{
        document.querySelector(`[data-action="change-layout-mode"][data-count="2"]`).click();
      }
    }
  }
});

